import React from 'react'
import { SvgIcon } from './SvgIcon'

interface Props {
  className?: string
}

export function GitBook({ className }: Props) {
  return (
    <SvgIcon className={className} viewBox="0 0 30 30" fill="currentColor">
      <path d="M13.78,20.86a.73.73,0,0,0-.72.72.72.72,0,0,0,.72.71.71.71,0,0,0,.71-.71A.72.72,0,0,0,13.78,20.86Z" />
      <path d="M25,15a.72.72,0,1,0,.71.71A.71.71,0,0,0,25,15Z" />
      <path d="M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0ZM25,17.94a2.19,2.19,0,0,1-1.37-.47L16,21.61a2.21,2.21,0,0,1-4.4.29L4.64,18.32a4.18,4.18,0,0,1-1.85-3.79A2.64,2.64,0,0,1,3.9,12.35c.37-.22,6.8-3.4,11.61-5.77l.26-.13a1.83,1.83,0,0,1,1.8,0c1.06.56,3.5,1.7,5.64,2.7l2.71,1.27a.57.57,0,0,1,.36.49.54.54,0,0,1-.38.48L14.13,17.49a1.13,1.13,0,0,1-1.21.06c-.24-.11-5.94-3.11-7.68-4l0,0a.62.62,0,0,0-.63,0,1.33,1.33,0,0,0-.5,1.12,2.87,2.87,0,0,0,1.16,2.55l6.56,3.45a2.24,2.24,0,0,1,2-1.23,2.21,2.21,0,0,1,1.82.95l7.31-3.88a2.16,2.16,0,0,1-.12-.71A2.22,2.22,0,1,1,25,17.94Z" />
    </SvgIcon>
  )
}
